'use strict'
import { serverApi } from '@/server';

export default {

    /**
     * 发票列表
     *
     * @author nick
     *
     * @method GET
     * 
     * 
     * @url /api/recharges
     * 
     * @returns {Promise}
     */
    getInvoiceList(formData) {
        const url = `/invoice`
        return serverApi.get(formData, url)
    },
    /**
     * 发票内容配置项
     *
     * @returns {Promise}
     */
    getSelectContentSetting() {
        const url = `/select-content-settings`
        return serverApi.get({}, url)
    },
    /**
     * 获取商户名
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @method GET
     * 
     * @url: /select-merchants
     */
    getMerchantsLis(formData) {
        const url = `/select-merchants`;
        return serverApi.get(formData, url);
    },
    /**
     * 发票详情
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @method GET
     * 
     * @url: /api/invoice-detail/331
     */
    getInvoiceDetail(id) {
        const url = `/invoice-detail/${id}`;
        return serverApi.get({}, url);
    },
    /**
     * 开票记录-获取开票详情冲红/作废列表
     *
     * @author nick
     *
     * @method POST
     *
     * @url /spa/delete-red-list/{invoiceId}
     *
     * @returns {Promise}
     */
    deleteRedList(invoiceId, formData = {}) {
        const url = `/delete-red-list/${invoiceId}`
        return serverApi.get(formData, url)

    },
    /*
     * 发票记录--详情信息
     *
     *
     * @returns {Promise}
     */
    getRecordDetailInfo(id) {
        const url = `/invoice-detail/${id}`
        return serverApi.get({}, url)
    },
    /**
     * 详情发票文件附件预览
     *
     * @author nick
     *
     * @method POST
     *
     * @url /invoice-detail-file/preview
     *
     * @returns {Promise}
     */
    invoiceDeleteRedFilePreview(formData) {
        const url = `/invoice-delete-red-file/preview`;
        return serverApi.preview(formData, url, { responseType: 'blob' });
    },
    /**
     * 详情发票文件附件预览pdf
     *
     * @author nick
     *
     * @method POST
     *
     * @url /invoice-detail-file/preview
     *
     * @returns {Promise}
     */
    invoiceDeleteRedFilePreviewPdf(formData) {
        const url = `/invoice-delete-red-file/preview`;
        return serverApi.post(formData, url);
    },
    /**
   * 详情发票图片附件预览
   *
   * @author nick
   *
   * @method POST
   *
   * @url /invoice-detail-file/preview
   *
   * @returns {Promise}
   */
    recordDetailImgPreview(formData) {
        const url = `/invoice-detail-file/preview`;
        return serverApi.preview(formData, url, { responseType: 'blob' });
    },
    /**
     * 详情发票文件附件预览
     *
     * @author nick
     *
     * @method POST
     *
     * @url /invoice-detail-file/preview
     *
     * @returns {Promise}
     */
    recordDetailFilePreview(formData) {
        const url = `/invoice-detail-file/preview`;
        return serverApi.preview(formData, url);
    },
    /**
     * 详情发票图片下载
     *
     * @author nick
     *
     * @method POST
     *
     * @url /invoice-detail-file/download
     *
     * @returns {Promise}
     */
    recordDetailFileDownload(formData, name) {
        const url = `/invoice-detail-file/download`
        return serverApi.downLoadByPost(formData, url, name)
    },
    /**
     * 详情发票所有图片压缩下载
     *
     * @author nick
     *
     * @method POST
     *
     * @url /invoice-detail-file/all-download
     *
     * @returns {Promise}
     */
    recordDetailAllFilesDownload(formData, name) {
        const url = `/invoice-detail-file/all-download`
        return serverApi.downLoadByPost(formData, url, name,true)
    },

}